import { DEFAULT_BODY_FONT, DEFAULT_HEADING_FONT } from "../../editor/fonts";
import { newProjectNumbering } from "../chapterNumbering";
import { DEFAULT_PRINT_SIZE } from "./types";
import type {
  ManuscriptItem,
  ZwChapterHeadingStyle,
  ZwConfig,
  ZwCopyrightPage,
  ZwDedicationPage,
  ZwGoals,
  ZwMetadata,
  ZwPageChrome,
  ZwParagraphFormatting,
  ZwSceneFormatting,
  ZwStatusBar,
} from "./types";

/** Defaults for on-disk `.zwconfig` fields plus empty local overlays. */
export function defaultZwPageChrome(): ZwPageChrome {
  return {
    showTitle: true,
    showAuthor: true,
    pageNumber: "header",
  };
}

export function defaultZwParagraphFormatting(): ZwParagraphFormatting {
  return {
    style: "indented",
    firstParagraph: "indented",
    openingInitial: "none",
    openingLeadIn: "none",
  };
}

export function defaultZwChapterHeadingStyle(): ZwChapterHeadingStyle {
  return {
    alignment: "center",
    spaceBefore: 0,
    spaceAfter: 0.8,
    scale: 1,
    image: "",
    imagePosition: "above",
  };
}

export function defaultZwSceneFormatting(): ZwSceneFormatting {
  return {
    showSceneTitles: false,
    breakStyle: "none",
    breakCustomText: "",
  };
}

export function defaultZwCopyrightPage(): ZwCopyrightPage {
  return {
    enabled: false,
    includeRightsParagraph: true,
    includeAiRestriction: true,
    editionLine: "",
    publishedBy: "",
    authorUrl: "",
    additionalText: "",
    credits: [],
  };
}

export function defaultZwDedicationPage(): ZwDedicationPage {
  return {
    enabled: false,
    text: "",
  };
}

export function defaultZwMetadata(): ZwMetadata {
  return {
    title: "",
    subtitle: "",
    author: "",
    language: "en",
    description: "",
    publisher: "",
    rights: "",
    isbn: "",
    lccn: "",
    subject: "",
    pubDate: "",
    coverImage: "",
  };
}

export function defaultZwStatusBar(): ZwStatusBar {
  return {
    wordCount: true,
    readingTime: true,
    zoom: true,
    goals: true,
    showNeighborScenePeeks: false,
  };
}

export function defaultZwGoals(): ZwGoals {
  return {
    sessionWords: null,
    dailyWords: null,
    projectWords: null,
  };
}

export function defaultZwConfig(manuscript: ManuscriptItem[] = []): ZwConfig {
  return {
    version: 1,
    manuscript,
    fonts: {
      body: DEFAULT_BODY_FONT,
      heading: DEFAULT_HEADING_FONT,
    },
    printSize: DEFAULT_PRINT_SIZE,
    paragraphFormatting: defaultZwParagraphFormatting(),
    chapterHeadingStyle: defaultZwChapterHeadingStyle(),
    chapterNumbering: newProjectNumbering("Chapter"),
    actNumbering: newProjectNumbering("Act"),
    chapterNumberingOverrides: {},
    pageChrome: defaultZwPageChrome(),
    sceneFormatting: defaultZwSceneFormatting(),
    copyrightPage: defaultZwCopyrightPage(),
    dedicationPage: defaultZwDedicationPage(),
    metadata: defaultZwMetadata(),
    dictionary: [],
    cloudProjectId: null,
    statusBar: defaultZwStatusBar(),
    goals: defaultZwGoals(),
    databaseFields: [],
    databaseRelationPairs: [],
  };
}
